<template>
  <div class="c-nav">
    <div class="table-header-container">
      <div class="action-bar batch-action-bar">
        <div class="action-item inbl">
          已选择{{ selectedRowKeys.length }}个计划
        </div>
        <div class="sp inbl"></div>
        <div class="action-item inbl" @click="batchAction(1)">
          <div class="action-item-inner">
            <a-icon type="caret-right" /><span class="item-text">启用</span>
          </div>
        </div>
        <div class="action-item inbl" @click="batchAction(2)">
          <div class="action-item-inner">
            <a-icon type="pause" /> <span class="item-text">暂停</span>
          </div>
        </div>
        <div class="action-item inbl" @click="batchAction(3)">
          <div class="action-item-inner">
            <a-icon type="delete" /> <span class="item-text">删除</span>
          </div>
        </div>
        <div class="action-item inbl" @click="batchAction(4)">
          <div class="action-item-inner">
            <a-icon type="reload" /> <span class="item-text">重建</span>
          </div>
        </div>
        <div class="sp inbl"></div>
        <div class="action-item inbl" @click="editAction(2)">
          <div class="action-item-inner">
            <span class="item-text">修改预算</span>
          </div>
        </div>
        <div
          class="action-item inbl"
          @click="editAction(3)"
          v-if="smart_bid_type == 'SMART_BID_CUSTOM'"
        >
          <div class="action-item-inner">
            <span class="item-text">修改ROI目标</span>
          </div>
        </div>

        <div class="action-item inbl" @click="addMaterial()">
          <div class="action-item-inner">
            <span class="item-text">+ 批量补素材</span>
          </div>
        </div>
        <!-- <div class="action-item inbl"  @click="ztAction(1)" v-if="smart_bid_type=='SMART_BID_CUSTOM'">
                    <div class="action-item-inner">
                        <span class="item-text">转投放量</span>
                    </div>
                </div>  
                <div class="action-item inbl"  @click="ztAction(2)" v-else >
                    <div class="action-item-inner">
                        <span class="item-text">转投控成本</span>
                    </div>
                </div>   -->

        <div class="sp inbl"></div>
        <div class="action-item inbl" v-if="false">
          <div class="action-item-inner">
            <a-icon type="edit" />
            <span class="item-text" @click="remarkVisible = true"
              >批量备注</span
            >
          </div>
        </div>
        <div class="action-item inbl" @click="batchWrite('add')">
          <div class="action-item-inner">
            <span class="item-text">+ 批量加白</span>
          </div>
        </div>
        <div class="action-item inbl" @click="batchWrite('del')">
          <div class="action-item-inner">
            <span class="item-text">- 取消加白</span>
          </div>
        </div>

        <div class="close">
          <a-icon type="close" @click="clearSelect" />
        </div>
      </div>
    </div>
    <a-modal
      v-if="closevisible"
      v-model="closevisible"
      :title="title"
      width="1050px"
      :okText="okText"
      :confirm-loading="batchLoading"
      @ok="stopAll"
      :zIndex="1001"
    >
      <div class="authTypeWapper">
        <div class="tips" v-if="type == 1">
          <a-alert
            :message="
              type == 1 ? '是否确定开启以下计划？' : '是否确定关停以下计划？'
            "
            banner
            type="info"
            show-icon
          />
        </div>
        <div class="tips" v-if="type == 2">
          <a-alert
            :message="
              type == 1 ? '是否确定开启以下计划？' : '是否确定关停以下计划？'
            "
            banner
            show-icon
          />
        </div>
        <div class="tips" v-if="type == 3">
          <a-alert
            message="是否确定批量删除以下计划？"
            banner
            type="error"
            show-icon
          />
        </div>
        <div class="tips" v-if="type == 4">
          <a-alert
            message="是否确定批量重建以下计划？重建将创建新的计划副本。"
            banner
            type="warning"
            show-icon
          />
        </div>
        <div
          v-if="type == 4"
          class="rebuild-roi-setting"
          style="
            margin-bottom: 16px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 12px;
          "
        >
          <a-checkbox v-model="rebuild_edit_roi">重建时修改ROI目标</a-checkbox>
          <div
            v-if="rebuild_edit_roi"
            style="
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              gap: 8px;
            "
          >
            <span style="font-weight: 600">修改方式</span>
            <a-input
              v-model="rebuild_edit_target"
              style="width: 320px"
              placeholder="请输入调整值"
            >
              <a-select
                slot="addonBefore"
                v-model="rebuild_edit_action"
                style="width: 96px"
              >
                <a-select-option value="1"> 修改为 </a-select-option>
                <a-select-option value="2"> 提高 </a-select-option>
                <a-select-option value="3"> 降低 </a-select-option>
              </a-select>
              <a-select
                slot="addonAfter"
                v-model="rebuild_edit_unit"
                style="width: 70px"
              >
                <a-select-option value="1"> 值 </a-select-option>
                <a-select-option value="2"> % </a-select-option>
              </a-select>
            </a-input>
            <a-button
              type="primary"
              size="small"
              style="margin-left: 8px"
              @click="applyRebuildRoi"
            >
              应用
            </a-button>
            <span style="color: #999">参考“修改ROI”计算规则</span>
          </div>
        </div>
        <a-table
          :columns="selectedcolumns"
          :data-source="stopData"
          :rowKey="(record, index) => index"
          :pagination="false"
          :scroll="{ y: 540 }"
        >
          <span slot="ad_id" slot-scope="text">{{ text?.ad_info?.id }}</span>
          <span slot="name" slot-scope="text">{{ text?.ad_info?.name }}</span>

          <span slot="stat_cost" slot-scope="text">{{
            text?.stats_info?.stat_cost
          }}</span>
          <span slot="pay_order_amount" slot-scope="text">{{
            text?.stats_info?.total_pay_order_gmv_for_roi2
          }}</span>
          <span slot="prepay_and_pay_order_roi" slot-scope="text">{{
            text?.stats_info?.total_prepay_and_pay_order_roi2
          }}</span>
          <span slot="old_roi" slot-scope="text">{{ text?.ad_info?.roi2_goal }}</span>
          <span slot="new_roi" slot-scope="text">{{ text?.edit_value || '-' }}</span>

          <a-tag slot="stop_status" slot-scope="text" v-if="text == '待执行'">{{
            text
          }}</a-tag>
          <a-tag
            color="green"
            slot="stop_status"
            slot-scope="text"
            v-else-if="text == 'OK'"
            >{{ text }}</a-tag
          >
          <a-tag color="red" slot="stop_status" slot-scope="text" v-else>{{
            text
          }}</a-tag>
          <span
            style="cursor: pointer; color: #1890ff"
            slot="cancel"
            slot-scope="text"
            @click="cancelSelect(text)"
            >移除</span
          >
        </a-table>
        <a-progress :percent="(count / stopData.length) * 100" size="small" />
      </div>
    </a-modal>

    <a-modal
      v-if="editvisible"
      v-model="editvisible"
      :title="title"
      width="1050px"
      :okText="okText"
      :confirm-loading="batchLoading"
      @ok="editAll"
      :zIndex="1001"
    >
      <div class="authTypeWapper">
        <div
          style="
            margin-bottom: 16px;
            display: flex;
            line-height: 30px;
            font-weight: 600;
          "
        >
          将符合条件的的计划，{{ title }}
          <a-input
            v-model="edit_target"
            style="width: 300px; margin-left: 20px"
          >
            <a-select
              slot="addonBefore"
              @change="changeEditAction"
              :default-value="edit_action"
              style="width: 90px"
            >
              <a-select-option value="1"> 修改为 </a-select-option>
              <a-select-option value="2"> 提高 </a-select-option>
              <a-select-option value="3"> 降低 </a-select-option>
            </a-select>
            <a-select
              slot="addonAfter"
              @change="changeEditUnit"
              :default-value="edit_unit"
              style="width: 60px"
            >
              <a-select-option value="1">
                {{ edittype == 3 ? '-' : '元' }}
              </a-select-option>
              <a-select-option value="2"> % </a-select-option>
            </a-select>
          </a-input>
          <a-button type="primary" @click="batchApply" style="margin-left: 20px"
            >全部应用</a-button
          >
        </div>

        <a-table
          :columns="editcolumns"
          :data-source="stopData"
          :rowKey="(record, index) => index"
          :pagination="false"
          :scroll="{ y: 540 }"
        >
          <div
            slot="name"
            slot-scope="text"
            class="ad_name"
            style="font-weight: bold; cursor: pointer"
          >
            {{ text }}
          </div>

          <span slot="ad_id" slot-scope="text">{{ text?.ad_info?.id }}</span>
          <span slot="name" slot-scope="text">{{ text?.ad_info?.name }}</span>

          <a-tag slot="stop_status" slot-scope="text" v-if="text == '待执行'">{{
            text
          }}</a-tag>
          <a-tag
            color="green"
            slot="stop_status"
            slot-scope="text"
            v-else-if="text == '修改成功'"
            >{{ text }}</a-tag
          >
          <a-tag color="red" slot="stop_status" slot-scope="text" v-else>{{
            text
          }}</a-tag>

          <div slot="old" slot-scope="text">
            <b v-if="edittype == '2'">预算 {{ text?.ad_info?.budget }} 元</b>
            <b v-if="edittype == '3'"
              >ROI目标 {{ text?.ad_info?.roi2_goal }}
            </b>
          </div>
          <b slot="target" style="color: green" slot-scope="text">{{
            text.edit_value
          }}</b>
          <span
            style="cursor: pointer; color: #1890ff"
            slot="cancel"
            slot-scope="text"
            @click="cancelSelect(text)"
            >移除</span
          >
        </a-table>
        <a-progress :percent="(count / stopData.length) * 100" size="small" />
      </div>
    </a-modal>

    <a-modal
      v-if="ztvisible"
      v-model="ztvisible"
      :title="title"
      width="1050px"
      :okText="okText"
      :confirm-loading="batchLoading"
      @ok="ztAll"
      :zIndex="1001"
    >
      <div class="authTypeWapper">
        <!-- 批量设置区域 -->
        <div
          class="batch-setting-area"
          style="padding: 15px; background: #f5f5f5; border-radius: 4px"
        >
          <a-row :gutter="16">
            <a-col :span="6">
              <a-form-item label="" style="margin-bottom: 0"
                >预算：
                <a-input-number
                  v-model="batchBudget"
                  placeholder="统一设置预算"
                  style="width: 140px"
                  :min="0"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="smart_bid_type != 'SMART_BID_CUSTOM'">
              <a-form-item label="" style="margin-bottom: 0"
                >ROI目标:
                <a-input-number
                  v-model="batchRoi"
                  placeholder="ROI目标"
                  style="width: 100px"
                  :min="0"
                  :step="0.01"
                  :precision="2"
                />
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <a-button
                style="margin-top: 5px"
                :loading="applyLoading"
                type="primary"
                @click="applyBatchSettings"
              >
                批量应用
              </a-button>
            </a-col>
          </a-row>
        </div>
        <a-table
          :dataSource="stopData"
          :rowKey="(record, index) => index"
          :pagination="false"
          :scroll="{ y: 430 }"
        >
          <a-table-column title="计划ID">
            <template slot-scope="text, record">
              {{ record?.ad_info?.id }}
            </template>
          </a-table-column>
          <a-table-column title="计划名称">
            <template slot-scope="text, record">
              {{ record?.ad_info?.name }}
            </template>
          </a-table-column>
          <a-table-column title="预算" width="120">
            <template slot-scope="text, record, index">
              <a-input-number
                :value="record.budget || ''"
                placeholder="输入预算"
                style="width: 120px"
                :min="0"
                @change="(value) => handleBudgetChange(value, index)"
              />
            </template>
          </a-table-column>
          <a-table-column
            title="支付ROI目标"
            width="120"
            v-if="smart_bid_type != 'SMART_BID_CUSTOM'"
          >
            <template slot-scope="text, record, index">
              <a-input-number
                :value="record.roi2_goal || ''"
                placeholder="输入ROI目标"
                style="width: 120px"
                :min="0"
                :step="0.01"
                :precision="2"
                @change="(value) => handleRoiChange(value, index)"
              />
            </template>
          </a-table-column>
          <a-table-column title="执行状态">
            <template slot-scope="text, record">
              <a-tag v-if="record.stop_status == '待执行'">{{
                record.stop_status
              }}</a-tag>
              <a-tag
                color="green"
                v-else-if="record.stop_status == '修改成功'"
                >{{ record.stop_status }}</a-tag
              >
              <a-tag color="red" v-else>{{ record.stop_status }}</a-tag>
            </template>
          </a-table-column>
          <a-table-column title="操作">
            <template slot-scope="text, record">
              <span
                style="cursor: pointer; color: #1890ff"
                @click="cancelSelect(record)"
                >移除</span
              >
            </template>
          </a-table-column>
        </a-table>
        <a-progress :percent="(count / stopData.length) * 100" size="small" />
      </div>
    </a-modal>

    <a-modal
      v-model="remarkVisible"
      title="批量设置备注"
      centered
      @ok="remarkBatch()"
    >
      <div class="batch-group-flex">
        备注：<a-textarea
          placeholder="请输入备注(选填)"
          v-model="remark"
          :rows="3"
          style="width: 80%; margin-left: 10px"
        />
      </div>
    </a-modal>

    <a-modal
      title="追加创意标题（每行一个，支持换行）"
      :visible="titleModalVisible"
      @ok="addMaterialAction"
      :confirm-loading="addloading"
      :okText="'确定补' + select_list.length + '条素材'"
      @cancel="titleModalVisible = false"
    >
      <a-textarea
        v-model="titleInput"
        :rows="4"
        placeholder="每行一个标题，支持换行"
        @input="handleTitleInput"
      />
      <div v-if="titleList.length" style="margin-top: 16px">
        <div
          v-for="(title, idx) in titleList"
          :key="idx"
          style="display: flex; align-items: center; margin-bottom: 8px"
        >
          <span style="flex: 1">{{ title }}</span>
          <a-icon
            type="delete"
            style="color: red; cursor: pointer"
            @click="removeTitle(idx)"
          />
        </div>
      </div>
    </a-modal>

    <addVideo
      v-if="videoVisible"
      :advertiser_id="advertiser_id"
      marketing_goal="VIDEO_PROM_GOODS"
      :aweme_id="aweme_id"
      @receive="videoreceive"
      :product_list="product_list"
      :newSelectList="newSelectList"
      @closeAddDrawer="closeAddDrawer"
    />

    <a-modal
      title="提示"
      :visible="resultvisible"
      :footer="null"
      width="700px"
      @cancel="resultvisible = false"
    >
      <a-result
        status="success"
        title="您的补素材任务已创建成功!"
        sub-title="请前往【千川全域】-》【任务管理】,查看任务具体执行进度。"
      >
        <template #extra>
          <a-button key="console" type="primary" @click="resultvisible = false">
            关闭弹窗
          </a-button>
          <a-button key="buy" @click="gotask"> 前往任务列表 </a-button>
        </template>
      </a-result>

      <br />
      <br />
    </a-modal>
  </div>
</template>

<script>
import { qcApi, requestHttp, isNumber, strLength } from '@utils/index';
import moment from 'moment';
import { Modal } from 'ant-design-vue';
import addVideo from '../../../../createPlanNew/components/addVideo.vue';
const copycolumns = [
  {
    title: '编号',
    dataIndex: 'xh',
    key: 'xh',
    width: 60,
    align: 'center',
    scopedSlots: { customRender: 'xh' },
  },
  {
    title: '原计划名称',
    key: 'adinfo',
    width: 165,
    scopedSlots: { customRender: 'adinfo' },
  },
  {
    title: '商品信息',
    key: 'aweme',
    align: 'center',
    width: 250,
    scopedSlots: { customRender: 'aweme' },
  },
  {
    title: '复制计划名称',
    key: 'target',
    align: 'center',
    width: 230,
    scopedSlots: { customRender: 'target' },
  },
  {
    title: '出价/Roi',
    align: 'center',
    key: 'cpa_bid',
    width: 80,
    scopedSlots: { customRender: 'cpa_bid' },
  },
  {
    title: '预算',
    align: 'center',
    key: 'budget',
    width: 80,
    scopedSlots: { customRender: 'budget' },
  },
  {
    title: '笔数',
    align: 'center',
    key: 'num',
    width: 60,
    scopedSlots: { customRender: 'num' },
  },
  {
    title: '操作状态',
    dataIndex: 'copy_status',
    align: 'center',
    key: 'copy_status',
    width: 130,
    scopedSlots: { customRender: 'copy_status' },
  },
  {
    title: '移除',
    key: 'cancel',
    align: 'center',
    width: 60,
    scopedSlots: { customRender: 'cancel' },
  },
];
const selectedcolumnsBase = [
  {
    title: '计划ID',
    key: 'ad_id',
    width: 160,
    scopedSlots: { customRender: 'ad_id' },
  },
  {
    title: '计划名称',
    key: 'name',
    width: 200,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '消耗',
    key: 'stat_cost',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'stat_cost' },
  },
  {
    title: '成交金额',
    key: 'pay_order_amount',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'pay_order_amount' },
  },
  {
    title: 'ROI',
    key: 'prepay_and_pay_order_roi',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'prepay_and_pay_order_roi' },
  },
  {
    title: '操作状态',
    dataIndex: 'stop_status',
    align: 'center',
    key: 'stop_status',
    width: 130,
    scopedSlots: { customRender: 'stop_status' },
  },
  {
    title: '移除',
    key: 'cancel',
    align: 'center',
    width: 100,
    scopedSlots: { customRender: 'cancel' },
  },
];
const selectedcolumnsRebuild = [
  {
    title: '计划ID',
    key: 'ad_id',
    width: 160,
    scopedSlots: { customRender: 'ad_id' },
  },
  {
    title: '计划名称',
    key: 'name',
    width: 200,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '原ROI',
    key: 'old_roi',
    width: 90,
    align: 'center',
    scopedSlots: { customRender: 'old_roi' },
  },
  {
    title: '修改后ROI',
    key: 'new_roi',
    width: 110,
    align: 'center',
    scopedSlots: { customRender: 'new_roi' },
  },
  {
    title: '操作状态',
    dataIndex: 'stop_status',
    align: 'center',
    key: 'stop_status',
    width: 130,
    scopedSlots: { customRender: 'stop_status' },
  },
  {
    title: '移除',
    key: 'cancel',
    align: 'center',
    width: 100,
    scopedSlots: { customRender: 'cancel' },
  },
];
const editcolumns = [
  {
    title: '计划ID',
    key: 'ad_id',
    width: 185,
    scopedSlots: { customRender: 'ad_id' },
  },
  {
    title: '计划名称',
    key: 'name',
    width: 200,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '原始值',
    key: 'old',
    align: 'center',
    scopedSlots: { customRender: 'old' },
  },
  {
    title: '修改为',
    key: 'target',
    align: 'center',
    scopedSlots: { customRender: 'target' },
  },
  {
    title: '操作状态',
    dataIndex: 'stop_status',
    align: 'center',
    key: 'stop_status',
    width: 250,
    scopedSlots: { customRender: 'stop_status' },
  },
  {
    title: '移除',
    key: 'cancel',
    align: 'center',
    scopedSlots: { customRender: 'cancel' },
  },
];
export default {
  name: 'action',
  props: {
    selectedRowKeys: {
      type: Array,
    },
    dataMap: {
      type: Object,
    },
    advertiser_id: {
      type: String,
      default: '',
    },
    smart_bid_type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      okText: '一键批量关停计划',
      title: '批量开启计划',
      selectedcolumns: selectedcolumnsBase,
      count: 0,
      stopData: [],
      closevisible: false,
      type: 1,
      editvisible: false,
      edittype: 1,
      editcolumns,

      edit_target: '',
      edit_action: '1',
      edit_unit: '1',
      rebuild_edit_roi: false,
      rebuild_edit_target: '',
      rebuild_edit_action: '1',
      rebuild_edit_unit: '1',

      copycolumns,
      copyvisible: false,
      copyData: [],

      batchnum: 1,
      batchbid: '',
      batchbudget: '',
      batchbh: 1,
      batchname: '{原计划名称}_复制_{编号}',
      tableKey: Math.random(),
      resultvisible: false,

      riseVisible: false,
      boostObj: {
        raise_budget: '',
        raise_raise_time: '',
        raise_raise_duration: '0.5',
      },
      boostType: 'NOW',
      defaultTime: '',

      remarkVisible: false,
      remark: '',
      ztvisible: false,

      batchBudget: '300',
      batchRoi: '',
      applyLoading: false,

      videoVisible: false,
      titleModalVisible: false,
      titleInput: '',
      titleList: [],
      select_list: [],
      addloading: false,
      product_list: {},
      newSelectList: [],
      aweme_id: '',
      resultvisible2: false,
      batchLoading: false,
    };
  },

  components: {
    addVideo,
  },

  watch: {},

  mounted() {
    console.log('子組件數據', this.selectedRowKeys);
    console.log('子組件數據dataMap', this.dataMap);
  },
  methods: {
    moment,
    goOnetask() {
      this.$router.replace('/planManage');
    },
    addMaterial() {
      this.newSelectList = [];
      this.aweme_id = this.dataMap[this.selectedRowKeys[0]]?.aweme_id;
      this.videoVisible = true;
    },
    videoreceive(value) {
      // 选中的视频
      console.log('选中的视频千川', value);
      //过滤
      let select_list = [];
      if (value.video_material_list.length > 0) {
        for (let i = 0; i < value.video_material_list.length; i++) {
          const item = value.video_material_list[i];
          console.log('item.source', item.source);
          select_list.push(item);
        }
        console.log('select_list-----------', select_list);
        if (select_list.length == 0) {
          this.$message.error('过滤完无可用素材');
          return;
        }
        this.select_list = select_list;
        this.titleModalVisible = true;
        this.titleInput = '';
        this.titleList = [];
      } else {
        this.$message.error('请选择视频');
      }
    },
    handleTitleInput(e) {
      this.titleInput = e.target.value;
      // 按行分割，去除空行
      this.titleList = this.titleInput
        .split('\n')
        .map((t) => t.trim())
        .filter((t) => t);
    },
    removeTitle(index) {
      this.titleList.splice(index, 1);
      // 同步回textarea
      this.titleInput = this.titleList.join('\n');
    },
    handleTitleModalOk() {
      // 这里可以将titleList提交到后端或做后续处理
      this.titleModalVisible = false;
    },
    async addMaterialAction() {
      // 校验：标题不能重复，且每个标题长度为5-55
      const titleSet = new Set();
      for (let i = 0; i < this.titleList.length; i++) {
        const title = this.titleList[i];
        if (titleSet.has(title)) {
          Modal.error({
            title: '提示',
            content: '意标题不能重复，请检查第' + (i + 1) + '个标题',
            zIndex: 1000002,
          });
          return;
        }
        titleSet.add(title);
        if (strLength(title) < 10 || strLength(title) > 110) {
          Modal.error({
            title: '提示',
            content: '第' + (i + 1) + '个创意标题长度需在5-55个字符之间',
            zIndex: 1000002,
          });
          return;
        }
      }
      const that = this;
      this.addloading = true;
      const selectRowArr = [];
      this.selectedRowKeys.forEach((item) => {
        selectRowArr.push(this.dataMap[item]);
      });
      console.log('-------', selectRowArr);
      console.log('-------', this.selectedRowKeys);
      console.log('-------', this.dataMap);
      for (let i = 0; i < selectRowArr.length; i++) {
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.ADD_QY_AD_MATERIAL}`,
          method: 'POST',
          params: {
            advertiser_id: selectRowArr[i].advertiser_id,
            ad_id: selectRowArr[i]?.ad_info?.id,
            marketing_goal: selectRowArr[i]?.ad_info?.marketing_goal,
            select_list: JSON.stringify(this.select_list),
            titleList: this.titleList.length > 0 ? this.titleList : '',
            aweme_id: selectRowArr[i]?.room_info[0]?.anchor_id,
            aweme_name: selectRowArr[i]?.room_info[0]?.anchor_name,
            aweme_avatar: selectRowArr[i]?.room_info[0]?.anchor_avatar,
            product_id: selectRowArr[i]?.product_info[0].product_id,
            product_name: selectRowArr[i]?.product_info[0].product_name,
            product_img: selectRowArr[i]?.product_info[0].product_image,
          },
        });
        if (code == 0) {
          that.$message.error({
            content: msg,
            duration: 3, // 3秒后自动关闭
            getContainer: () => document.body, // 显式挂载到 body
          });
        }
      }
      this.addloading = false;
      this.resultvisible = true;
      this.videoVisible = false;
      this.titleModalVisible = false;
    },
    closeAddDrawer() {
      this.videoVisible = false;
    },
    applyBatchSettings() {
      this.applyLoading = true;
      this.stopData.forEach((item, index) => {
        if (this.batchBudget !== null && this.batchBudget !== undefined) {
          this.$set(item, 'budget', this.batchBudget);
        }
        if (this.batchRoi !== null && this.batchRoi !== undefined) {
          this.$set(item, 'roi2_goal', this.batchRoi);
        }
      });
      this.applyLoading = false;
    },
    remarkBatch() {
      const that = this;
      Modal.confirm({
        title: '设置备注',
        content: '是否确定批量设置选中的计划备注为' + that.remark + '？',
        onOk: () => {
          that.remarkBatchApi();
        },
      });
    },
    async remarkBatchApi() {
      console.log('备注', this.selectedRowKeys);
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.QY_ADD_BATCH_REMARK}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          marketing_goal: 'VIDEO_PROM_GOODS',
          ad_ids: this.selectedRowKeys.join(','),
          remark: this.remark,
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.$message.success(msg);
      this.remark = '';
      this.$emit('clearSelect');
    },
    batchWrite(type) {
      const that = this;
      Modal.confirm({
        title: '加白提醒',
        content:
          type == 'add'
            ? '是否确定加白该计划？加白后该计划后该计划将不会被监控。'
            : '是否确定取消加白该计划？取消加白后该计划后该计划将会重新被监控。',
        onOk: () => {
          that.addwhiteAction(type);
        },
      });
    },
    async addwhiteAction(type) {
      const selectRowArr = [];
      this.selectedRowKeys.forEach((item) => {
        selectRowArr.push(this.dataMap[item]);
      });
      console.log(type, selectRowArr);
      for (let i = 0; i < selectRowArr.length; i++) {
        const e = selectRowArr[i];
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.QY_ADD_AD_WHITE}`,
          method: 'POST',
          params: {
            advertiser_id: e.advertiser_id,
            ad_id: e?.ad_info?.id,
            marketing_goal: 'VIDEO_PROM_GOODS',
            order_create_day: e?.ad_info?.create_time,
            type: type,
          },
        });
        if (code == 0) {
          this.$message.error(msg);
          return;
        }
      }
      this.$message.success('执行完毕！');
      this.$emit('clearSelect');
    },
    // 复制操作
    text_copy(context) {
      navigator.clipboard
        .writeText(context)
        .then(() => {
          this.$message.success('复制成功');
        })
        .catch((err) => {
          this.$message.error('复制失败');
        });
    },
    gotask() {
      this.$router.replace('/qy_task');
    },
    copyAll() {
      if (this.count == this.copyData.length) {
        this.copyvisible = false;
        return;
      }
      let batchid = moment().format('YYYYMMDDHHmmss');
      if (this.copyData.length == 0) {
        this.$message.error('请选择需要操作的计划');
        return;
      }
      for (let i = 0; i < this.copyData.length; i++) {
        if (
          !isNumber(this.copyData[i].delivery_setting_budget) ||
          !isNumber(this.copyData[i].copynum)
        ) {
          this.$message.error('编号' + (i + 1) + '字段异常');
          return;
        }
        if (this.copyData[i].copynum > 100 || this.copyData[i].copynum < 1) {
          this.$message.error('编号' + (i + 1) + '投放笔数需在1-100笔内');
          return;
        }
        if (
          this.copyData[i].delivery_setting_budget < 300 ||
          this.copyData[i].delivery_setting_budget > 9999999.99
        ) {
          this.$message.error('编号' + (i + 1) + '预算需在300-9999999.99内');
          return;
        }
        if (
          this.getLength(this.copyData[i].new_name) > 97 ||
          this.getLength(this.copyData[i].new_name) < 2
        ) {
          this.$message.error('编号' + (i + 1) + '计划名称长度需在1-50以内');
          return;
        }
      }
      Modal.confirm({
        title: '提醒',
        zIndex: 10005,
        content: '确定是否批量复制计划？',
        onOk: () => {
          this.copyOrderTask(batchid);
        },
      });
      console.log(batchid);
    },
    async copyOrderTask(batchid) {
      for (let i = 0; i < this.copyData.length; i++) {
        let copyrule = { copynum: this.copyData[i].copynum };
        if (
          this.copyData[i].delivery_setting_deep_external_action ==
          'AD_CONVERT_TYPE_LIVE_PAY_ROI'
        ) {
          copyrule.editkey = '2';
          copyrule.delivery_roi = 'COUNT';
          copyrule.roi_data = [];
          for (let j = 0; j < this.copyData[i].copynum; j++) {
            copyrule.roi_data.push({
              name:
                this.copyData[i].copynum > 1
                  ? this.copyData[i].new_name + j
                  : this.copyData[i].new_name,
              roi_goal: this.copyData[i].new_value,
              budget: this.copyData[i].delivery_setting_budget,
              name_rule: 'diy',
            });
          }
        } else {
          copyrule.editkey = '1';
          copyrule.delivery_bid = 'COUNT';
          copyrule.bid_data = [];
          for (let j = 0; j < this.copyData[i].copynum; j++) {
            copyrule.bid_data.push({
              name:
                this.copyData[i].copynum > 1
                  ? this.copyData[i].new_name + j
                  : this.copyData[i].new_name,
              cpa_bid: this.copyData[i].new_value,
              budget: this.copyData[i].delivery_setting_budget,
              name_rule: 'diy',
            });
          }
        }
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.QC_ADD_COPY_TASK}`,
          method: 'POST',
          params: {
            advertiser_id: this.copyData[i].advertiser_id,
            ad_id: this.copyData[i].ad_id,
            copyrule: JSON.stringify(copyrule),
            times: this.copyData[i].copynum,
            name: this.copyData[i].name,
            batch_id: batchid,
            batch_name: this.batchname,
            // campaign_id:this.copyForm.campaign_id,
            // dotime:this.dotime
          },
        });
        this.count++;
        if (code == 1) {
          this.copyData[i].copy_status = 'OK';
        } else {
          this.copyData[i].copy_status = msg;
        }
      }
      this.okText = '执行完毕';
      this.$message.success('复制完毕！');
    },
    getLength(str) {
      // let zw = str.length - str.replace(/[\u4e00-\u9fa5]/g, '').length
      // let sz = str.replace(/[\u4e00-\u9fa5]/g, '').length
      // return sz
      let length = 0;
      for (let i = 0; i < str.length; i++) {
        length += str.charCodeAt(i) > 255 ? 2 : 1;
      }
      return length;
    },
    async editAll() {
      if (this.stopData.length == 0) {
        this.$message.error('请筛选符合条件需要执行的计划！');
        return;
      }

      if (this.count < this.stopData.length && this.count) {
        return;
      }
      if (this.count == this.stopData.length) {
        this.editvisible = false;
        this.batchLoading = false;
        this.$emit('clearSelect');
        return;
      }

      if (this.stopData[0].edit_value == '待修改') {
        this.$message.error('请输入您要修改的值点击全部应用后提交修改');
        return;
      }

      this.batchLoading = true;
      this.okText = '执行中';
      const that = this;
      const suc = 0;
      let stop_status = '修改成功';
      for (let i = 0; i < this.stopData.length; i++) {
        // 检查edit_value是否存在
        if (!this.stopData[i].edit_value || this.stopData[i].edit_value === '待修改') {
          this.$set(this.stopData[i], 'stop_status', '跳过：未设置修改值');
          that.count = i + 1;
          continue;
        }
        
        try {
          const { code, msg, data } = await requestHttp({
            api: `${qcApi.EDIT_QY_AD_NEW}`,
            method: 'POST',
            params: {
              advertiser_id: this.stopData[i].advertiser_id,
              ad_id: this.stopData[i].ad_info.id,
              edittype: this.edittype,
              edit_value: this.stopData[i].edit_value,
              old_value: this.edittype == 2?this.stopData[i].ad_info.budget:this.stopData[i].ad_info.roi2_goal,
            },
          });
          if (code == 1) {
            this.$set(this.stopData[i], 'stop_status', stop_status);
          } else {
            this.$set(this.stopData[i], 'stop_status', msg || '修改失败');
          }
        } catch (error) {
          console.error(`修改计划 ${this.stopData[i].ad_info.id} 失败:`, error);
          this.$set(this.stopData[i], 'stop_status', '请求失败');
        }
        that.count = i + 1;
        
        // 添加短暂延迟，避免API频率限制
        if (i < this.stopData.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 200));
        }
      }
      this.okText = '执行完毕';
      this.batchLoading = false;
      this.$message.success('执行完毕！');
    },

    async ztAll() {
      console.log(11111111111111111);
      if (this.stopData.length == 0) {
        this.$message.error('请筛选符合条件需要执行的计划！');
        return;
      }

      console.log(2222222222222);
      if (this.count < this.stopData.length && this.count) {
        return;
      }
      console.log(3333333333333, this.count);
      console.log(3333333333333, this.stopData.length);

      if (this.count == this.stopData.length) {
        this.ztvisible = false;
        this.batchLoading = false;
        this.$emit('clearSelect');
        return;
      }

      console.log(444444444444444);
      // if(this.stopData[0].edit_value == '待修改'){
      //     this.$message.error('请输入您要修改的值点击全部应用后提交修改');
      //     return;
      // }

      this.batchLoading = true;
      this.okText = '执行中';
      const that = this;
      const suc = 0;
      let stop_status = '修改成功';
      for (let i = 0; i < this.stopData.length; i++) {
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.ZHUANTOU_QY_AD}`,
          method: 'POST',
          params: {
            advertiser_id: this.stopData[i].advertiser_id,
            ad_id: this.stopData[i].ad_info.id,
            budget: this.stopData[i].budget,
            roi2_goal: this.stopData[i].roi2_goal,
            smart_bid_type: this.smart_bid_type,
          },
        });
        if (code == 1) {
          this.stopData[i].stop_status = stop_status;
        } else {
          this.stopData[i].stop_status = msg;
        }
        that.count = i + 1;
      }
      this.okText = '执行完毕';
      this.batchLoading = false;
      this.$message.success('执行完毕！');
    },
    handleBudgetChange(value, index) {
      this.$set(this.stopData[index], 'budget', value);
    },
    handleRoiChange(value, index) {
      this.$set(this.stopData[index], 'roi2_goal', value);
    },
    changeEditAction(e) {
      this.edit_action = e;
    },
    changeEditUnit(e) {
      this.edit_unit = e;
    },
    batchApply() {
      if (this.stopData.length > 0) {
        if (!this.edit_target && this.edit_target !== 0) {
          this.$message.error('请输入需要调整的值');
          return;
        }
        const targetNum = Number(this.edit_target);
        if (isNaN(targetNum) || this.edit_target === '' || this.edit_target === null || this.edit_target === undefined) {
          this.$message.error('请输入正确的数值');
          return;
        }
        const updatedData = [];
        for (let i = 0; i < this.stopData.length; i++) {
          let old_value = '';
          if (this.edittype == 1) {
            old_value = this.stopData[i].delivery_setting_cpa_bid;
          } else if (this.edittype == 2) {
            old_value = this.stopData[i].ad_info.budget;
          } else if (this.edittype == 3) {
            old_value = this.stopData[i].ad_info.roi2_goal;
          }
          const value = this.calcEditValue(
            old_value,
            this.edit_target,
            this.edit_action,
            this.edit_unit
          );
          // 创建新对象确保响应式
          updatedData.push({
            ...this.stopData[i],
            edit_value: value || '待修改'
          });
        }
        // 重新赋值整个数组以触发响应式更新
        this.stopData = updatedData;
        console.log('应用后', this.stopData);
      } else {
        this.$message.info('请筛选符合条件的计划进行调整');
        return;
      }
    },
    applyRebuildRoi() {
      if (!this.rebuild_edit_roi) {
        this.$message.info('请先勾选"重建时修改ROI目标"');
        return;
      }
      const targetNum = Number(this.rebuild_edit_target);
      if (isNaN(targetNum) || this.rebuild_edit_target === '' || this.rebuild_edit_target === null || this.rebuild_edit_target === undefined) {
        this.$message.error('请输入正确的ROI数值');
        return;
      }
      if (this.stopData.length === 0) {
        this.$message.info('请先选择计划');
        return;
      }
      let dd = this.stopData;
      for (let i = 0; i < dd.length; i++) {
        const old_value = dd[i]?.ad_info?.roi2_goal;
        const roiGoal = this.calcEditValue(
          old_value,
          this.rebuild_edit_target,
          this.rebuild_edit_action,
          this.rebuild_edit_unit
        );
        if (roiGoal === '') {
          dd[i].edit_value = '-';
        } else {
          dd[i].edit_value = roiGoal;
        }
      }
      this.stopData = [];
      this.stopData = dd;
    },
    ztAction(type) {
      if (type == 1) {
        this.okText = '一键批量转投放量';
        this.title = '批量转投放量';
      } else if (type == 2) {
        this.okText = '一键批量转投控成本';
        this.title = '批量转投控成本';
      }
      this.count = 0;
      this.ztvisible = true;
      if (this.selectedRowKeys.length == 0) {
        this.$message.info('请选择要操作的计划');
        return;
      }
      const selectRowArr = [];
      this.selectedRowKeys.forEach((item) => {
        if (this.dataMap[item]) {
          selectRowArr.push(this.dataMap[item]);
        }
      });
      selectRowArr.forEach(function (item) {
        item.edit_value = '待修改';
        item.stop_status = '待执行';
        item.budget = item?.ad_info?.budget;
        item.roi2_goal = item?.ad_info?.roi2_goal;
      });
      this.stopData = selectRowArr;
      console.log('selectRowArr1AAAAA', selectRowArr);
    },
    editAction(type) {
      this.edittype = type;
      // this.$message.info('开发中...');
      // return;
      if (type == 1) {
        this.okText = '一键批量修改出价';
        this.title = '批量修改出價';
      } else if (type == 2) {
        this.okText = '一键批量修改预算';
        this.title = '批量修改預算';
      } else if (type == 3) {
        this.okText = '一键批量修改ROI目标';
        this.title = '批量修改ROI目标';
      }
      this.count = 0;
      this.editvisible = true;
      if (this.selectedRowKeys.length == 0) {
        this.$message.info('请选择要操作的计划');
        return;
      }
      const selectRowArr = [];
      this.selectedRowKeys.forEach((item) => {
        if (this.dataMap[item]) {
          selectRowArr.push(this.dataMap[item]);
        }
      });
      selectRowArr.forEach(function (item) {
        item.edit_value = '待修改';
        item.stop_status = '待执行';
      });
      this.stopData = selectRowArr;
      console.log('selectRowArr1AAAAA', selectRowArr);
    },
    cancelSelect(text) {
      this.stopData = this.stopData.filter(function (item) {
        return item.ad_id != text.ad_id;
      });
    },
    cancelCopy(text) {
      this.copyData = this.copyData.filter(function (item) {
        return item.ad_id != text.ad_id;
      });
    },
    batchAction(type) {
      this.type = type;
      if (type == 1) {
        this.okText = '一键批量开启计划';
        this.title = '批量开启计划';
      } else if (type == 2) {
        this.okText = '一键批量关停计划';
        this.title = '批量关停计划';
      } else if (type == 3) {
        this.okText = '一键批量删除计划';
        this.title = '批量删除计划';
      } else if (type == 4) {
        this.okText = '一键批量重建计划';
        this.title = '批量重建计划';
        this.selectedcolumns = selectedcolumnsRebuild;
      } else {
        this.selectedcolumns = selectedcolumnsBase;
      }
      this.count = 0;
      this.closevisible = true;
      if (this.selectedRowKeys.length == 0) {
        this.$message.info('请选择要操作的计划');
        return;
      }
      const selectRowArr = [];
      this.selectedRowKeys.forEach((item) => {
        if (this.dataMap[item]) {
          selectRowArr.push(this.dataMap[item]);
        }
      });
      selectRowArr.forEach(function (item) {
        item.stop_status = '待执行';
      });
      this.stopData = selectRowArr;
      console.log('selectRowArr1AAAAA', this.dataMap);
      if (type == 4) {
        this.resetRebuildRoiForm();
      }
    },
    async stopAll() {
      if (this.count < this.stopData.length && this.count) {
        return;
      }
      if (this.count == this.stopData.length) {
        this.closevisible = false;
        this.batchLoading = false;
        this.$emit('clearSelect');
        return;
      }
      this.batchLoading = true;
      this.okText = '执行中';
      const that = this;
      const suc = 0;
      let opt_status = '';
      let stop_status = '';
      if (this.type == 1) {
        opt_status = 'ENABLE';
        stop_status = '开启成功';
      } else if (this.type == 2) {
        opt_status = 'DISABLE';
        stop_status = '关停成功';
      } else if (this.type == 3) {
        opt_status = 'DELETE';
        stop_status = '删除成功';
      } else if (this.type == 4) {
        opt_status = 'REBUILD';
        stop_status = '重建成功';
        if (this.rebuild_edit_roi) {
          if (!this.rebuild_edit_target && this.rebuild_edit_target !== 0) {
            this.$message.error('请输入需要调整的ROI值');
            this.batchLoading = false;
            return;
          }
          const targetNum = Number(this.rebuild_edit_target);
          if (isNaN(targetNum) || this.rebuild_edit_target === '' || this.rebuild_edit_target === null || this.rebuild_edit_target === undefined) {
            this.$message.error('请输入正确的ROI数值');
            this.batchLoading = false;
            return;
          }
        }
      }

      // let ad_ids = []
      // for (let i = 0; i < this.stopData.length; i++) {
      //     ad_ids.push(this.stopData[i].ad_id)
      // }

      // const { code, msg, data } = await requestHttp({
      //     api: `${qcApi.STOP_QY_AD}`,
      //     method: 'POST',
      //     params: {
      //         advertiser_id: this.advertiser_id,
      //         ad_id: ad_ids.join(','),
      //         opt_status:opt_status
      //     },
      // });
      // if (code == 0) {
      //     this.$message.error(msg);
      //     return;
      // }
      // for (let i = 0; i < this.stopData.length; i++) {
      //     this.count = i + 1;
      //     let ad_id = this.stopData[i].ad_id
      //     let res = data.filter(function(item){
      //         return item.ad_id == ad_id
      //     })
      //     this.stopData[i].stop_status = res[0].msg
      // }
      console.log(this.stopData);
      for (let i = 0; i < this.stopData.length; i++) {
        let apiUrl = qcApi.STOP_QY_AD;
        let params = {
          advertiser_id: this.stopData[i].advertiser_id,
          ad_id: this.stopData[i].ad_info.id,
          opt_status: opt_status,
          type: this.type,
        };
        if (this.type == 4 && this.rebuild_edit_roi) {
          const old_value = this.stopData[i]?.ad_info?.roi2_goal;
          const roiGoal = this.calcEditValue(
            old_value,
            this.rebuild_edit_target,
            this.rebuild_edit_action,
            this.rebuild_edit_unit
          );
          if (roiGoal === '') {
            this.$message.error(
              `计划 ${this.stopData[i]?.ad_info?.id || ''} 缺少原ROI，无法按所选方式计算`
            );
            this.batchLoading = false;
            return;
          }
          params.roi2_goal = roiGoal;
          params.is_edit_roi = 1;
          this.$set(this.stopData[i], 'edit_value', roiGoal || '-');
        }
        const { code, msg, data } = await requestHttp({
          api: apiUrl,
          method: 'POST',
          params: params,
        });
        this.stopData[i].stop_status = msg;
        that.count = i + 1;
      }
      this.okText = '执行完毕';
      this.batchLoading = false;
      this.$message.success('执行完毕！');
    },
    calcEditValue(old_value, target, action, unit) {
      // 判断target是否为有效数字（包括小数）
      const targetNum = Number(target);
      if (isNaN(targetNum) || target === '' || target === null || target === undefined) {
        return '';
      }
      
      // 判断old_value是否为有效数字（包括小数）
      const oldNum = Number(old_value);
      const hasOld = !isNaN(oldNum) && old_value !== '' && old_value !== null && old_value !== undefined;
      
      const targetVal = targetNum;
      const oldVal = hasOld ? oldNum : 0;
      let value = 0;
      
      if (action == 1) {
        // 修改为
        if (unit == 1) {
          // 直接修改为固定值
          value = targetVal;
        } else {
          // 修改为百分比
          if (hasOld) {
            value = (oldVal * targetVal) / 100;
          } else {
            return '';
          }
        }
      } else if (action == 2) {
        // 提高
        if (!hasOld) return '';
        if (unit == 1) {
          // 固定值提高
          value = oldVal + targetVal;
        } else {
          // 百分比提高
          value = oldVal + (oldVal * targetVal) / 100;
        }
      } else if (action == 3) {
        // 降低
        if (!hasOld) return '';
        if (unit == 1) {
          // 固定值降低
          value = oldVal - targetVal;
        } else {
          // 百分比降低
          value = oldVal - (oldVal * targetVal) / 100;
        }
      }
      
      return Number(value).toFixed(2);
    },
    resetRebuildRoiForm() {
      this.rebuild_edit_roi = false;
      this.rebuild_edit_target = '';
      this.rebuild_edit_action = '1';
      this.rebuild_edit_unit = '1';
    },
    clearSelect() {
      this.$emit('clearSelect');
    },
  },
};
</script>

<style lang="less" scoped>
.c-nav {
  position: relative;
  .table-header-container {
    position: absolute;
    top: 0px;
    z-index: 90;
    height: 40px;
    line-height: 40px;
    width: 100%;
    .action-bar {
      text-align: left;
      padding: 10px;
      background: #edf1fd;
      border-radius: 4px;
      color: #1890ff;
      font-size: 14px;
      overflow: hidden;
      padding: 0 16px;
      position: relative;
      height: 40px;
      line-height: 40px;
      border-radius: 5px;
      position: relative;
      .close {
        position: absolute;
        right: 20px;
        top: 0px;
        cursor: pointer;
        &:hover {
          color: #1890ff;
        }
      }
    }
  }
}
.action-bar .sp {
  background: #99aff4;
  height: 12px;
  margin: 0 24px;
  width: 1px;
}
.inbl,
.inbltop {
  display: inline-block;
  font-weight: 600;
  vertical-align: middle;
  cursor: pointer;
  &::hover {
    color: #375dcf;
  }
}
.action-item {
  margin-right: 24px;
  position: relative;
}
.ad_name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 175px;
}

.aweme {
  display: flex;
  padding-left: 20px;
}

.aweme-right {
  text-align: left;
  padding-left: 10px;

  .aweme-title {
    color: #323335;
    // font-weight: bold;
    // margin-bottom: 5px;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 180px;
  }
}
.videoimg {
  width: 40px;
  height: 40px;
  border-radius: 3px;
  cursor: pointer;
}
</style>
